import { RG_TYPE as t, getRgObjectsOfType as o } from "@project-rouge/rg-core";
import { getCountOfType as r } from "../../counting/index.js";
const n = (e) => r(o(e, t.Apartment), t.Module);
export {
  n as getApartmentModuleCount
};
//# sourceMappingURL=index5.js.map
